import React, { useState } from 'react';
import {
  Box,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Text,
  VStack,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import { AppPasswordInput, PrimaryButton } from '../../../components/ui';

export default function SignIn() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    if (!email.trim() || !password) {
      setError('Email and password are required');
      return;
    }
    setSubmitting(true);
    try {
      await login(email.trim(), password);
      navigate('/admin/dashboard');
    } catch (err) {
      setError(err?.message || 'Sign in failed');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Box as="form" onSubmit={handleSubmit}>
      <VStack spacing={5} align="stretch">
        <Box>
          <Heading size="lg" color="text.primary">
            Utkarsh Admin
          </Heading>
          <Text color="text.secondary" mt={2}>
            Sign in to manage villagers, vendors, and matching.
          </Text>
        </Box>
        <FormControl isInvalid={Boolean(error) && !email.trim()}>
          <FormLabel>Email</FormLabel>
          <Input
            type="email"
            placeholder="admin@utkarsh.com"
            h="52px"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="username"
          />
        </FormControl>
        <AppPasswordInput
          label="Password"
          placeholder="••••••••"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="current-password"
          isInvalid={Boolean(error) && !password}
        />
        {error ? (
          <Text color="red.500" fontSize="14px">
            {error}
          </Text>
        ) : null}
        <PrimaryButton type="submit" w="100%" isLoading={submitting}>
          Sign in
        </PrimaryButton>
      </VStack>
    </Box>
  );
}
